import { Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";

// POs and delivery notes share one lifecycle enum, derived from allocations on the backend. Tones mirror the match view.

const fmtQty = (q: number | string | null | undefined) => String(Number(q ?? 0));

const STATUS_META: Record<string, { label: string; className?: string }> = {
  Draft: { label: "Draft" },
  Open: { label: "Open" },
  PartiallyMatched: {
    label: "Partially matched",
    className: "border-amber-500/30 bg-amber-500/15 text-amber-600",
  },
  FullyMatched: {
    label: "Fully matched",
    className: "border-emerald-500/30 bg-emerald-500/15 text-emerald-600",
  },
  Closed: { label: "Closed" },
  Cancelled: { label: "Cancelled" },
};

// Falls back to the raw status string for any unmapped value.
export function DocStatusBadge({ status }: { status?: string | null }) {
  const meta = status ? STATUS_META[status] : undefined;
  if (!meta) return <Badge variant="secondary">{status ?? "-"}</Badge>;
  if (!meta.className) return <Badge variant="secondary">{meta.label}</Badge>;
  return (
    <Badge variant="outline" className={meta.className}>
      {meta.label}
    </Badge>
  );
}

export function LineMatchBadge({
  matchedQuantity,
  totalQuantity,
  fullyMatched,
}: {
  matchedQuantity?: number | string | null;
  totalQuantity?: number | string | null;
  fullyMatched?: boolean | null;
}) {
  const matched = Number(matchedQuantity ?? 0);
  if (matched <= 0) return <span className="text-xs text-muted-foreground">-</span>;
  if (fullyMatched) {
    return (
      <Badge variant="outline" className="border-emerald-500/30 bg-emerald-500/15 text-emerald-600">
        <Check className="size-3" /> Matched
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="border-amber-500/30 bg-amber-500/15 text-amber-600">
      Partial · {fmtQty(matchedQuantity)}/{fmtQty(totalQuantity)}
    </Badge>
  );
}
